// extracted by mini-css-extract-plugin
module.exports = {"skeletonWrapper":"ProfileCollectionSkeleton_skeletonWrapper__2G793"};